import * as React from 'react'
import classNames from 'classnames'
import s from './updated-indication.scss'
import {UpdatedIndicationProps} from '.'

export const UpdatedIndication = ({formattedUpdatedDate, t, inModal}: UpdatedIndicationProps) => (
  <div className={classNames(s.container, {[s.inModal]: inModal})}>
    <div className={s.pimple} />
    <div className={s.updatedIndicationText}>
      {t('updated')} {formattedUpdatedDate}
    </div>
  </div>
)
